import { Injectable } from '@angular/core';
import { sizeBucket } from '../../shared/helpers/size-bucket';
import { BlendEvent, StreamingSaveOutcome, StreamingSaveOutcomeProps, StreamingSaveSeam } from '../../shared/models';
import { BlendService } from '../../shared/services/blend.service';
import { TRANSFER_STATUS } from '../models/transfer.model';

/** Product names the funnel by event rather than by property, so each outcome gets its own event. */
const EVENT_BY_OUTCOME: Readonly<Record<StreamingSaveOutcome, BlendEvent>> = {
  [StreamingSaveOutcome.INITIATED]: BlendEvent.FILE_STREAM_INITIATED,
  [StreamingSaveOutcome.COMPLETED]: BlendEvent.FILE_STREAM_COMPLETED,
  [StreamingSaveOutcome.CANCELLED]: BlendEvent.FILE_STREAM_CANCELLED,
  [StreamingSaveOutcome.FAILED]: BlendEvent.FILE_STREAM_FAILED,
  [StreamingSaveOutcome.FELL_BACK]: BlendEvent.FILE_STREAM_NOT_STARTED,
  [StreamingSaveOutcome.PICKER_CANCELLED]: BlendEvent.FILE_STREAM_NOT_STARTED,
};

/** Maps a transfer's terminal status onto the funnel's vocabulary; an absent status is a failure, not a success. */
export function streamingOutcomeForStatus(status?: number): StreamingSaveOutcome {
  if (status === TRANSFER_STATUS.STATUS_SUCCESS) {
    return StreamingSaveOutcome.COMPLETED;
  }
  return status === TRANSFER_STATUS.STATUS_DOWNLOAD_CANCELLED
    ? StreamingSaveOutcome.CANCELLED
    : StreamingSaveOutcome.FAILED;
}

@Injectable({
  providedIn: 'root',
})
export class StreamingSaveTelemetryService {
  constructor(private blendService: BlendService) {}

  public track(props: StreamingSaveOutcomeProps): void {
    const { totalSizeBytes } = props;
    const fileCount = props.fileCount ?? (props.seam === StreamingSaveSeam.SINGLE_FILE ? 1 : undefined);
    this.blendService.track(EVENT_BY_OUTCOME[props.outcome], {
      ...this.withoutUndefined(props),
      ...(fileCount !== undefined && { fileCount }),
      ...(typeof totalSizeBytes === 'number' && { sizeBucket: sizeBucket(totalSizeBytes) }),
    });
  }

  private withoutUndefined(props: StreamingSaveOutcomeProps): { [key: string]: unknown } {
    return Object.fromEntries(Object.entries(props).filter(([, value]) => value !== undefined));
  }
}
